import Chart from "chart.js/auto";
import "chartjs-adapter-date-fns";
import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { RiskscoreService } from "./riskscore.service";
import { Riskscore } from "@aptsi-types";
import {
  AdaptiveAccessChart,
  AdaptiveAccessReport,
  Header,
} from "@aptsi-types";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { AdaptiveAccessReportService } from "./reports.service";
import jsPDF from "jspdf";
import { AdaptiveaccessDashboardService } from "../auth-tool-home/dashboard.service";
import {
  AbstractControl,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";

@Component({
  selector: "app-aac-reports",
  templateUrl: "./aac-reports.component.html",
  styleUrls: ["./aac-reports.component.scss"],
})
export class AacReportsComponent {
  adaptiveAccessReport: AdaptiveAccessReport[] = [];
  headerCaptureReport: AdaptiveAccessReport[] = [];
  accessAttemptReport: AdaptiveAccessReport[] = [];
  chartdata: AdaptiveAccessChart[] = [];
  sanitizedPdfUrl: SafeResourceUrl | null = null;
  isView: boolean = false;

  constructor(
    private adaptiveAccessReportService: AdaptiveAccessReportService,
    private adaptiveAccessDashboardService: AdaptiveaccessDashboardService,
    private sanitizer: DomSanitizer
  ) { }

  filterOptions = [
    { label: "Last 7 Days", value: "last_7_days" },
    { label: "Last Month", value: "last_month" },
    { label: "All time", value: "all_time" },
  ];

  selectedFilter: string = "all_time";

  // form: FormGroup;

  headers: { header_1: Header[]; header_2: Header[]; header_3: Header[] } = {
    header_1: [
      {
        name: "Asset Name",
        property: "assetname",
      },
      {
        name: "Access Type",
        property: "accesstype",
      },
      {
        name: "Risk Score",
        property: "riskscore",
      },
      {
        name: "Access Threshold",
        property: "accessthreshold",
      },
    ],

    header_2: [
      {
        name: "User ID",
        property: "userid",
      },
      {
        name: "Ip Address",
        property: "ipaddress",
      },
      {
        name: "User Agent",
        property: "useragent",
      },

      {
        name: "Create Date",
        property: "createdate",
      },
    ],

    header_3: [
      {
        name: "Asset Id",
        property: "assetid",
      },
      {
        name: "Avg Risk Score",
        property: "avg_risk_score",
      },

      {
        name: "Access Attempts",
        property: "access_attempts",
      },

      {
        name: "Granted Access",
        property: "granted_access",
      },

      {
        name: "High Risk Attempts",
        property: "high_risk_attempts",
      },

      {
        name: "Denied Access",
        property: "denied_access",
      },
    ],
  };

  async ngOnInit(): Promise<void> {
    this.fetchReportData();
    this.fetchChartData();
  }

  chartData: any = {
    labels: [],
    datasets: [],
  };

  async fetchChartData(filter?: string) {
    try {
      if (filter) {
        this.selectedFilter = filter;
      }
      this.chartdata = [];

      const response = await this.adaptiveAccessDashboardService
        .getAcDashboardChartData(this.selectedFilter)
        .toPromise();
      console.log(response);

      this.chartdata = response["recentAccessControls"];

      console.log("Line chart data:", this.chartdata);

      // Check if timestamps are valid
      this.chartdata.forEach((item) =>
        console.log("Parsed Date:", new Date(item.timestamp).toISOString())
      );

      // Update the chartData object dynamically after fetching data
      this.chartData = {
        labels: this.chartdata.map(
          (item) =>
            new Date(item.timestamp).toLocaleDateString("en-US", {
              year: "numeric",
              month: "short",
              day: "numeric",
            }) // Example: "Mar 23, 2025"
        ),
        datasets: [
          {
            label: "Risk Score",
            data: this.chartdata.map((item) => item.riskscore),
            borderColor: "rgba(75,192,192,1)",
            backgroundColor: "rgba(75,192,192,0.2)",
            borderWidth: 2,
            fill: false,
            tension: 0.3,
          },
          {
            label: "Threshold",
            data: this.chartdata.map((item) => item.accessthreshold),
            borderColor: "rgba(255,99,132,1)",
            backgroundColor: "rgba(255,99,132,0.2)",
            borderWidth: 2,
            fill: false,
            tension: 0.3,
            borderDash: [5, 5],
          },
        ],
      };
    } catch (error) {
      console.error("Error fetching chart data:", error);
    }
  }

  // Chart options to customize tooltips and X-axis labels
  chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      tooltip: {
        enabled: true,
        callbacks: {
          title: (tooltipItems) => {
            const index = tooltipItems[0].dataIndex;
            return new Date(this.chartdata[index].timestamp).toLocaleString(
              "en-US",
              {
                year: "numeric",
                month: "short",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: true,
              }
            ); // Show full timestamp on hover
          },
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Date",
        },
      },
      y: {
        title: {
          display: true,
          text: "Risk Score",
        },
        min: 0,
        max: 100,
      },
    },
  };

  async fetchReportData(filter?: string) {
    try {
      if (filter) {
        this.selectedFilter = filter;
      }
      this.adaptiveAccessReport = [];
      this.headerCaptureReport = [];
      this.accessAttemptReport = [];

      const response = await this.adaptiveAccessReportService
        .getAcReports(this.selectedFilter)
        .toPromise();
      this.adaptiveAccessReport = response["recentAccessControls"];
      this.headerCaptureReport = response["headerCaptureReport"];
      this.accessAttemptReport = response["accessAttemptReport"];
    } catch (error) {
      console.error("Error fetching report data:", error);
    }
  }

  async generateAndDownloadPDF() {
    await this.fetchReportData();

    if (!this.hasReportData) {
      return;
    }

    const doc = this.createPDFDocument(
      this.adaptiveAccessReport,
      this.headerCaptureReport,
      this.accessAttemptReport
    );

    doc.save("AssetManagementReport.pdf");
  }

  async generateAndViewPDF() {
    await this.fetchReportData();

    if (!this.hasReportData) {
      return;
    }

    const doc = this.createPDFDocument(
      this.adaptiveAccessReport,
      this.headerCaptureReport,
      this.accessAttemptReport
    );

    const pdfBlob = doc.output("blob");
    const pdfBlobUrl = URL.createObjectURL(pdfBlob);

    this.sanitizedPdfUrl =
      this.sanitizer.bypassSecurityTrustResourceUrl(pdfBlobUrl);

    this.isView = true;
  }

  get hasReportData(): boolean {
    return (
      this.adaptiveAccessReport?.length > 0 ||
      this.headerCaptureReport?.length > 0 ||
      this.accessAttemptReport?.length > 0
    );
  }

  close() {
    this.isView = !this.isView;
  }

  private createPDFDocument(
    assetSourceSummaryReport: AdaptiveAccessReport[],
    headerCaptureReport: AdaptiveAccessReport[],
    accessAttemptReport: AdaptiveAccessReport[]
  ) {
    const doc = new jsPDF();

    // Add title
    doc.setFontSize(18);
    doc.text("Asset Management Report", 14, 10);

    // Add spacing
    doc.setFontSize(14);
    doc.text("Asset Source Summary", 14, 20);

    // Prepare table data for Asset Source Summary
    const tableData1 = assetSourceSummaryReport.map((item) => [
      item.assetname,
      item.accesstype,
      item.riskscore,
      item.accessthreshold,
    ]);

    // Add table to the PDF
    (doc as any).autoTable({
      startY: 25,
      head: [["Asset Name", "Access Type", "Risk Score", "Access Threshold"]],
      body: tableData1,
      theme: "striped",
      headStyles: { fillColor: [40, 78, 120], textColor: 255 },
      styles: { fontSize: 10 },
    });

    // Add spacing
    doc.addPage();
    doc.setFontSize(14);
    doc.text("Header Capture Report", 14, 20);

    // Prepare table data for Header Capture Report
    const tableData2 = headerCaptureReport.map((item) => [
      item.ipaddress,
      item.useragent,
      item.userid,
      item.createdate,
    ]);

    (doc as any).autoTable({
      startY: 25,
      head: [["IP Address", "User Agent", "User ID", "Create Date"]],
      body: tableData2,
      theme: "striped",
      headStyles: { fillColor: [40, 78, 120], textColor: 255 },
      styles: { fontSize: 10 },
    });

    // Add spacing
    doc.addPage();
    doc.setFontSize(14);
    doc.text("Access Attempt Report", 14, 20);

    // Prepare table data for Access Attempt Report
    const tableData3 = accessAttemptReport.map((item) => [
      item.assetid,
      item.avg_risk_score,
      item.access_attempts,
      item.granted_access,
      item.high_risk_attempts,
      item.denied_access,
    ]);

    (doc as any).autoTable({
      startY: 25,
      head: [
        [
          "Asset ID",
          "Avg Risk Score",
          "Access Attempts",
          "Granted Access",
          "High Risk Attempts",
          "Denied Access",
        ],
      ],
      body: tableData3,
      theme: "striped",
      headStyles: { fillColor: [40, 78, 120], textColor: 255 },
      styles: { fontSize: 10 },
    });

    return doc; // Return the jsPDF document object
  }
}
